import React, { PureComponent, Fragment } from 'react';
import { number, func, array, bool } from 'prop-types';
import cn from 'classnames';
import './index.css';

export default class Switcher extends PureComponent {
  static displayName = 'Switcher';

  render() {
    const { title, leftAction, rightAction, theme, disabled } = this.props;
    const switcherCSS = cn(
      'switcher',
      theme && theme.map(css => `switcher--${css}`).join(' ')
    );

    return (
      <Fragment>
        <div className={switcherCSS}>
          {!disabled && (
            <button
              role="button"
              className="switcher__button chevron chevron--left"
              onClick={leftAction}
            />
          )}
          {title.toString()}
          {!disabled && (
            <button
              role="button"
              className="switcher__button chevron chevron--right"
              onClick={rightAction}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

Switcher.propTypes = {
  title: number.isRequired,
  leftAction: func,
  rightAction: func,
  theme: array,
  disabled: bool,
};

Switcher.defaultProps = {
  disabled: false,
};



// WEBPACK FOOTER //
// ./src/common/components/Switcher/index.js